import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import vol from "../../assests/volume.png";
import set from "../../assests/settings.png";
import back from "../../assests/back-w.svg";

const Support: React.FC = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="bg-[#3E3E3E] h-[90px] w-full flex items-center justify-between px-3 ">
        <div className="flex gap-2 text-white font-outfit">
          <div onClick={() => navigate("/kitchen")}>
            <img src={back} alt="back" className="h-9 w-8" />
          </div>
          <h3>Support</h3>
        </div>

        <div className="flex items-center gap-4">
          <div className="h-10 text-white flex items-center gap-3 justify-center">
            <img
              src={set}
              alt="Logo"
              className="w-[30px] h-[30px] bg-[#636363] rounded-full"
              onClick={() => navigate("/kitchen/setting")}
            />
            <img
              src={vol}
              alt="Logo"
              className="w-[30px] h-[30px] bg-white rounded-full"
              onClick={() => navigate("/kitchen/notification")}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Support;
